export default __webpack_public_path__ + "static/media/equal.6e26333e.svg";